import styled from "styled-components";
import { calcRem } from "styles/theme";

export const Body = styled.div`
  width: 100%;
  max-width: 560px;

  .stepper-container {
    width: 100%;
    padding-top: 20px;
  }

  .inner-content {
    padding-top: 8px;
  }
`;

export const ConfirmBody = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.COLORS.WHITE};
  text-align: center;
  padding: 20px 0;

  .detail {
    margin-top: 8px;
    font-size: ${calcRem(14)};
    color: ${({ theme }) => theme.COLORS.WHITE}80;
    line-height: 1.35;
  }
`;
